module.exports = "/images/vendor/flag-icon-css/flags/4x3/xk.svg?62bc9bcf96e7abb6e21278b2e9714817";